export default __webpack_public_path__ + "static/media/bira-carvalho.f8dea8d4.ogg";